<div class="address-form-cont" *ngIf="!!addressForm">
  <div class="address-form-row" #streetElementRef>
    <div class="address-form-inputs">
      <app-form-text-input
        [ngStyle]="{ 'width': '100%' }"
        [form]="addressForm"
        [formControlSelector]="streetFormControl"
        [id]="streetFormControl"
        [maxLength]="50"
        [isSubmitted]="isSubmitted"
        [placeholder]="'BOOKING_MODULE.BILLING.ADDRESS' | transloco"
        (keyUp)="changeUpperCaseName($event, streetFormControl, addressForm)"
        (click)="scrollToAddressInputRef(streetRef)">
      </app-form-text-input>
    </div>
  </div>
  <ng-container *ngIf="isActiveFullAddressForm">
    <div class="address-form-row flex-center">
      <div class="address-form-inputs" #neighborhoodElementRef>
        <app-form-text-input
          [style]="'input-flex'"
          [form]="addressForm"
          [formControlSelector]="neighborhoodFormControl"
          [id]="neighborhoodFormControl"
          [maxLength]="15"
          [isSubmitted]="isSubmitted"
          [placeholder]="'BOOKING_MODULE.BILLING.NEIGHBORHOOD' | transloco"
          (click)="scrollToAddressInputRef(neighborhoodRef)">
        </app-form-text-input>
        <section #cepElementRef>
          <app-form-text-input
            [form]="addressForm"
            [style]="'input-flex margin'"
            [formControlSelector]="cepFormControl"
            [id]="cepFormControl"
            [maxLength]="15"
            [isSubmitted]="isSubmitted"
            [placeholder]="'BOOKING_MODULE.BILLING.CEP' | transloco"
            (click)="scrollToAddressInputRef(cepRef)">
          </app-form-text-input>
        </section>
      </div>
    </div>
    <div class="address-form-row" #complementElementRef>
      <div class="address-form-inputs">
        <app-form-text-input
          [ngStyle]="{ 'width': '100%' }"
          [form]="addressForm"
          [formControlSelector]="complementFormControl"
          [id]="complementFormControl"
          [maxLength]="50"
          [isSubmitted]="isSubmitted"
          [placeholder]="'BOOKING_MODULE.BILLING.COMPLEMENT' | transloco"
          (keyUp)="changeUpperCaseName($event, complementFormControl, addressForm)"
          (click)="scrollToAddressInputRef(complementRef)">
        </app-form-text-input>
      </div>
    </div>
  </ng-container>
  <div class="address-form-row" #countryElementRef>
    <app-country-selector
      [form]="form"
      [activeForm]="isActiveForm"
      [isBilling]="true"
      [defaultCode]="defaultCountryCode"
      [countries]="countries"
      [canSetCities]="true"
      [selector]="countryFormControl"
      [isSubmitted]="isSubmitted"
      [disabledCountryOptions]="disabledCountryOptions"
      [isMobile]="isMobile"
      (selected)="selectedCountry.emit($event)">
    </app-country-selector>
  </div>
  <div class="address-form-row" #cityElementRef>
    <app-form-city-selector
      [cities]="cities"
      [defaultCity]="defaultCity$ | async"
      [form]="form"
      [isSubmitted]="isSubmitted"
      [isMobile]="isMobile"
      (selected)="selectedCity.emit($event)">
    </app-form-city-selector>
  </div>
  <ng-container *ngIf="isActiveFullAddressForm">
    <div class="address-form-row" #stateRef>
      <app-form-state-selector
        [form]="form"
        [isSubmitted]="isSubmitted"
        [defaultProvince]="defaultStateCode"
        [cities]="cities"
        [isMobile]="isMobile"
        [defaultCity]="defaultCity$ | async"
        [provinces]="defaultCity$ | async | provincesBy | async">
      </app-form-state-selector>
    </div>
  </ng-container>
</div>